import React, { PureComponent } from 'react';
import { Container, H1, H2 } from './styles';

const TOKEN_NOT_FOUND_IMAGE = 'https://quiqup-track.s3.amazonaws.com/images/token-not-found.png';

export default class InvalidToken extends PureComponent {
  render() {
    return (
      <Container>
        <img src={TOKEN_NOT_FOUND_IMAGE} alt="This link has expired or is not valid." />
        <H1>Oops! There doesn’t seem to be anything to track</H1>
        <H2>This link has expired or is not valid.</H2>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/invalid-token/InvalidToken.js